/**
 * PAPPO — Mood Service ("Como você tá?")
 * A criança marca/lê o humor do dia.
 */

import { apiGet, apiPost } from './api';

export type MoodKey =
  | 'feliz'
  | 'bem'
  | 'mais_ou_menos'
  | 'triste'
  | 'bravo'
  | 'ansioso';

/** Humor de hoje da criança logada (ou null). */
export async function getTodayMood() {
  return apiGet<{ today: { mood: MoodKey } | null }>('/mood/today');
}

/** Registra o humor de hoje (UPSERT — 1 por dia). */
export async function setMood(mood: MoodKey) {
  return apiPost<{ mood: MoodKey }>('/mood', { mood });
}
